import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ChangeDetectorRef,
  SimpleChanges,
  OnChanges,
  ViewChild, AfterViewInit
} from "@angular/core";
import {ComCashNeedsGridLayoutService} from "./com-cash-needs.grid-layout.service";
import {CalltoactionService} from "@irb/irb-common/components/calltoaction/calltoaction.service";
import {IrbSettingsService} from "@irb/irb-settings/irb-settings.service";
import {DatePipe, formatDate} from "@angular/common";
import {ISetAsideDto} from "@irb/irb-editors/irb-editors.model";
import {IrbEditorComponent} from '@irb/irb-editors/irb-editors.com';
import {NumberTextBoxComponent} from "@irb-common/components/number-text-box/number-text-box.component";
import { EasternTimePipe } from "@irb/irb-common/pipes/EasternTimePipe";
import { IGlobalSettings } from "@irb/irb-settings/irb-settings.model";
import { IrbSettingsEvents } from '@irb/irb-common/events';
import {IUserDetails} from "@irb/app.model";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {FormControl} from "@angular/forms";

@Component({ standalone: false,
  selector: "irb-com-cash-needs",
  templateUrl: "./com-cash-needs.component.html",
  styleUrls: ["./com-cash-needs.component.scss"],
})
export class ComCashNeedsComponent extends IrbEditorComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild("cashMinPerc") cashMinPerc: NumberTextBoxComponent;
  @ViewChild("cashTargetPerc") cashTargetPerc: NumberTextBoxComponent;
  @ViewChild("cashMaxPerc") cashMaxPerc: NumberTextBoxComponent;
  @ViewChild("cashMinDollar") cashMinDollar: NumberTextBoxComponent;
  @ViewChild("cashTargetDollar") cashTargetDollar: NumberTextBoxComponent;
  @ViewChild("cashMaxDollar") cashMaxDollar: NumberTextBoxComponent;
  @ViewChild("setAsidePercent") setAsidePercent: NumberTextBoxComponent;
  @ViewChild("setAsideDollar") setAsideDollar: NumberTextBoxComponent;
  @ViewChild("trxCashMinSettingRef") trxCashMinSettingRef: any;
  @ViewChild("cashEquivSettingRef") cashEquivSettingRef: any;
  @ViewChild("trxCashMinValueRef") trxCashMinValueRef: NumberTextBoxComponent;

  @Input() isValid: boolean;
  @Input() globalSettings: IGlobalSettings;
  @Output() isValidChange = new EventEmitter<boolean>();
  @Output() change = new EventEmitter<boolean>();
  originalData: any;
  grid: any;
  gridOptions: any;
  emptyGridOptions:any;
  emptyGrid:any;
  startDate: any;
  endDate: any;
  startDateControl: any = new FormControl('');
  endDateCalendarStartAt: any;
  value: number;
  notesToAdd: string;
  setAsideAmountSymbol: string = "%";
  rowCount: number;
  activeRowCount: number;
  expiredRowCount: number;
  activeAmount: string;
  tooltipMessage: any = "";
  tooltipShow: boolean = false;
  resetValue = new EventEmitter<void>();
  cashMinimum: any;
  cashTarget: any;
  cashMaximum: any;
  cashFloor: any;
  isUiTest = false;
  frameworkComponents: any;
  isExternalAcct: boolean;
  isSMA: boolean;
  showAutoCashHoldForDist: boolean;
  isDistHoldCashEnabled: boolean;
  isCashEqvEnabled: boolean;
  ENABLE_SETASIDE_CASH: boolean;
  userDetails: IUserDetails;
  uiReady: boolean = false;
  trxCashMinSettings: Array<IDropdownItem> = [
    {name: 'Use global targets', value: 'Set global'},
    {name: 'Set custom', value: 'Set custom'}
  ];
  trxCashMinSetting: IDropdownItem;
  trxCashMinValue: number = 0;
  trxCashMinInd: string = 'P';
  cashEquivSettings: Array<IDropdownItem> = [
    {name: 'Use model targets', value: 'model'},
    {name: 'Use global targets', value: 'global'},
    {name: 'Set custom', value: 'custom'}
  ];

   cashEquivSetting: IDropdownItem = this.cashEquivSettings[2];
  private readonly maxSetAsideGridHeight = 200;

  constructor(
    private cdr: ChangeDetectorRef,
    private gls: ComCashNeedsGridLayoutService,
    private ctas: CalltoactionService,
    public iss: IrbSettingsService,
    private datePipe: DatePipe,
    private easternTimePipe: EasternTimePipe,
  ) {
    super();
    const dateArr = this.util.formatEasternDate((new Date()).getTime(), '-').split('-');
    const todayDate = dateArr[2] + '-' + dateArr[0] + '-' + dateArr[1] + ' 12:00 PM GMT';
    this.today = new Date (todayDate);
    this.startDate = new Date (todayDate);
    this.startDateControl.setValue(new Date (todayDate));
    this.endDate = '';
    const tomorrow = new Date(this.today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.endDateCalendarStartAt = tomorrow;
    this.setAsideAmountSymbol = '%';
    this.userDetails = this.as.getItem("IRB_APP_CONFIG") as IUserDetails;
    this.isDistHoldCashEnabled = this.userDetails?.isDistHoldCashEnabled || false;
    this.isCashEqvEnabled = this.userDetails?.isCashEqvEnabled || false;
    this.ENABLE_SETASIDE_CASH = this.userDetails?.featureFlags['enable-setaside-cash']  || false;
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(this),
      floatingFilter: false,
      overlayNoRowsTemplate:
        "<span class='ag-overlay-loadGriding-center ag-overlay-message'>No Set Aside Cash Data</span>",
      context: {componentParent: this},
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
    };
    this.emptyGridOptions = {
      columnDefs: this.gls.getColumnDefs(this),
      floatingFilter: false,
      overlayNoRowsTemplate:
        "<span class='ag-overlay-loadGriding-center ag-overlay-message'>No Set Aside Cash Data</span>",
      context: {componentParent: this},
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
    };

    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  _data: any;

  @Input()
  get data(): any {
    return this._data;
  }
  set data(d: any) {
    this.startDate = this.today;
    this.endDate = '';
    this.value = null;
    this.hideToolTip();
    this._data = d;
    this.trxCashMinInd = d.trxCashMinSetting === "Set global" ? 'P' : d.trxCashMinInd;
    this.trxCashMinValue = d.trxCashMinValue;
    this.loadCashMinimumMaximum()
    this.markAsTouched();
  }

  _modelFlag: any = "Model";

  get modelFlag(): any {
    return this._modelFlag;
  }

  set modelFlag(m: any) {
    this._modelFlag = m;
  }

  _cashNeedsData: Array<ISetAsideDto> = [];

  @Input()
  get cashNeedsData(): any {
    return this._cashNeedsData;
  }

  set cashNeedsData(d: any) {
    this._cashNeedsData = d;
  }

  today: any;

  _setAsideAmountPlaceholder: string = "0%";

  get setAsideAmountPlaceholder() {
    return this._setAsideAmountPlaceholder;
  }

  set setAsideAmountPlaceholder(setAsideAmountPlaceholder: string) {
    this._setAsideAmountPlaceholder = setAsideAmountPlaceholder;
  }

  ngOnInit() {
    this.markAsTouched();
    this.isExternalAcct = this.data?.accountsubType === "EXTERNAL";
    this.isSMA = this.data?.isSMA;
    const matchedSetting: any | undefined = this.trxCashMinSettings.find(setting => setting.value === this.data.trxCashMinSetting);
    if (matchedSetting) {
      this.trxCashMinSetting = matchedSetting;
    }
    this.cashEquivSetting = this.data.isGlobal? this.cashEquivSettings[1]: (this.data.useModelCashAtAccount? this.cashEquivSettings[0]: this.cashEquivSettings[2]);
    this.updateAutoCashHoldForDistAmt();

    setTimeout(() => { 
      this.uiReady = true; 
      this.cdr.detectChanges();
    }, 2000);
  }

  setTrxCashMinSetting(event: IDropdownItem) {
    this.trxCashMinSetting = event;
    this.data.trxCashMinSetting = this.trxCashMinSetting.value;
    if(this.trxCashMinSetting.value === 'Set custom') {
      if (this.trxCashMinValue === null) {
        this.trxCashMinValue = 0;
        this.data.trxCashMinValue = 0;
        this.trxCashMinInd = 'P';
        this.data.trxCashMinInd = this.trxCashMinInd;
      }
    } else if (this.trxCashMinSetting.value === 'Set global') {
        this.trxCashMinValue = this.data.globalTrxMinValue || 0;
        this.data.trxCashMinValue = this.data.globalTrxMinValue || 0;
        this.trxCashMinInd = 'P';
        this.data.trxCashMinInd = this.trxCashMinInd;
    }
    this.markAsTouched();
    this.onInputChange();
  }

  setCashEquivSetting(event: IDropdownItem) {
      if (event?.value === 'model') {
        this.data.useModelCashAtAccount = true;
        this.data.isGlobal = false;
      } else if (event.value === 'global') {
        this.data.useModelCashAtAccount = false;
        this.data.isGlobal = true;
      } else {
        this.data.useModelCashAtAccount = false;
        this.data.isGlobal = false;
      }
      if ((this.globalSettings?.useModelCash && this.data?.isGlobal) || this.data?.useModelCashAtAccount) {
        this.modelFlag = "Model";
      } else {
        this.modelFlag = "";
      }
      if (this.data.isGlobal) {
        this.data.cashMinimum = this.originalData.globalCashMinimum;
        this.data.cashMaximum = this.originalData.globalCashMaximum;
        this.data.cashTarget = this.originalData.globalCashTarget;
        this.cashMinimum = this.originalData.globalCashMinimum?.replace(/%/g, '').replace(/\$/g, '');
        this.cashMaximum = this.originalData.globalCashMaximum?.replace(/%/g, '').replace(/\$/g, '');
        this.cashTarget = this.originalData.globalCashTarget?.replace(/%/g, '').replace(/\$/g, '');
        this.data.isPercentage = (this.originalData.globalCashMinimum) ? this.originalData.globalCashMinimum.endsWith("%") : true;
      } else {
        this.data.cashMinimum = (this.data.useModelCashAtAccount) ? this.originalData.cashMinimum : null;
        this.data.cashMaximum = (this.data.useModelCashAtAccount) ? this.originalData.cashMaximum : null;
        this.data.cashTarget = (this.data.useModelCashAtAccount) ? this.originalData.cashTarget : null;
        this.cashMinimum = null;
        this.cashMaximum = null;
        this.cashTarget = null;
        this.data.isPercentage = true;
      }
      this.markAsTouched();
      this.onInputChange();
  }

  populateTrxCashMinSettingDropdown(searchStr: string) {
      const f = DropdownFilterComponent.getFilteredList( searchStr, this.trxCashMinSettings);
      this.trxCashMinSettingRef.set(f);
  }

  populateCashEquivSettingDropdown(searchStr: string) {
      const f = DropdownFilterComponent.getFilteredList( searchStr, this.cashEquivSettings);
      this.cashEquivSettingRef.set(f);
  }

  onTrxCashMinValueChange() {
      this.data.trxCashMinValue = this.trxCashMinValue;
      this.onInputChange();
  }

  onDataLoad() {
    this.originalData = this.util.clone(this.data);
    this.loadCashMinimumMaximum();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cashNeedsData && !changes.cashNeedsData.firstChange) {
      this.loadGrid();
    }
  }

  onExpressAs() {
    this.markAsTouched();

    setTimeout(() => {
      this.onInputChange();
    });
  }

  onExpressCashMinAs() {
    this.data.trxCashMinInd = this.trxCashMinInd;
    this.markAsTouched();

    setTimeout(() => {
      this.onInputChange();
    });
  }
  onGridReady(params: any) {
    this.grid = params;
    this.loadGrid();
  }

  onEmptyGridReadyForSma(params:any) {
    this.emptyGrid = params;
    this.loadEmptyGridForSma();
  }

  loadEmptyGridForSma() {
    if (this.emptyGrid && this.emptyGrid.api) {
      this.emptyGrid.api.setGridOption('rowData', []);
    }
  }

  addToGrid() {
    this.tooltipMessage = "";
    this.tooltipShow = false;

    if (!this.checkSetAsideDuplicates() && !this.checkForValidInput()) {

    const startDateStr = this.startDate instanceof Date
      ? this.datePipe.transform(this.startDate, 'yyyy-MM-dd')
      : this.startDate;
    const endDateStr = this.endDate instanceof Date
      ? this.datePipe.transform(this.endDate, 'yyyy-MM-dd')
      : this.endDate;

      const dCreated = startDateStr + ' 04:00:00 -0400';
      const dEnd = endDateStr ? endDateStr + ' 04:00:00 -0400' : null;

      const now = new Date().getTime();
      const startDate = new Date(dCreated).getTime();
      const endDate = dEnd ? new Date(dEnd).getTime() : null;
      let isActive = false;
      if (startDate <= now && (endDate >= now || endDate === null)) {
        isActive = true;
      }
      const outdata: ISetAsideDto = {} as ISetAsideDto;
      outdata.accountNumber = this.data.accountNumber;
      outdata.accountID = this.data.accountID;
      outdata.isDeleted = false;
      outdata.isNewSACadded = true;
      outdata.isPercent = this.setAsideAmountSymbol === "%" ? true : false;
      outdata.setAsideCashId = null;
      outdata.startDate = startDate;
      outdata.endDate = endDate;
      outdata.notes = this.notesToAdd;
      outdata.isActive = isActive;
      if (this.value === null || this.value === undefined || this.value.toString() === "") {
        this.value = 0;
      }

      outdata.value = this.setAsideAmountSymbol === "%" ? this.value + "%" : "$" + this.value;

      this.resetValue.emit();

      if (this.cashNeedsData) {
        this.cashNeedsData.push(outdata);
        this.notesToAdd='';
      } else {
        this.cashNeedsData = outdata;
      }

      this.loadGrid();
      this.cashNeedsData.isActive = false;
      this.data.oSetAsideDTO = this.cashNeedsData;
      this.onInputChange();
      this.startDate = this.today;
      this.endDate = '';
      this.value=null;
    } else {
      this.tooltipShow = true;
    }
  }

  checkSetAsideDuplicates() {
  let dupFlag = false;

  const startDateStr = this.startDate instanceof Date
    ? this.datePipe.transform(this.startDate, 'yyyy-MM-dd')
    : this.startDate;
  const endDateStr = this.endDate instanceof Date
    ? this.datePipe.transform(this.endDate, 'yyyy-MM-dd')
    : this.endDate;

  if(!this.ENABLE_SETASIDE_CASH) {
    for (let i = 0; i < this.cashNeedsData.length; i++) {
      if (
        this.datePipe.transform(this.cashNeedsData[i].startDate, "yyyy-MM-dd") === startDateStr
        && !this.cashNeedsData[i].isDeleted
      ) {
        const startDateDisplay = this.datePipe.transform(this.cashNeedsData[i].startDate, "MM-dd-yyyy");
        dupFlag = true;
        this.tooltipMessage = startDateDisplay + " is already being used as a scheduled start date for a set-aside amount in this account.<br>Please select a different start date.";
      }
    }
  } else {
    for (let i = 0; i < this.cashNeedsData.length; i++) {
      if (!this.cashNeedsData[i].isDeleted) {
        const existingStartDate = this.datePipe.transform(this.cashNeedsData[i].startDate, "yyyy-MM-dd");
        const existingEndDate = this.datePipe.transform(this.cashNeedsData[i].endDate, "yyyy-MM-dd");

        if (existingStartDate === startDateStr) {
          const bothEndDatesEmpty = (!existingEndDate || existingEndDate === 'null') && (!endDateStr || endDateStr === '');
          const bothEndDatesMatch = existingEndDate === endDateStr;

          if (bothEndDatesEmpty || bothEndDatesMatch) {
            dupFlag = true;
            this.tooltipMessage = "An entry with the same start date and end date already exists. Please select different dates.";
            break;
          }
        }
      }
    }
  }

  return dupFlag;
}

  checkForValidInput() {
  let errFlag = false;
  const reg: RegExp = /^\d+$/;

  const startDateStr = this.startDate instanceof Date
    ? this.datePipe.transform(this.startDate, 'yyyy-MM-dd') + ' 12:00:00 GMT'
    : this.startDate;
  const endDateStr = this.endDate instanceof Date
    ? this.datePipe.transform(this.endDate, 'yyyy-MM-dd') + ' 12:00:00 GMT'
    : this.endDate;

  let isValidStartDateInput = this.isValidCalendarDate(startDateStr);
  let isValidEndDateInput = true;

  if (this.ENABLE_SETASIDE_CASH && endDateStr) {
    isValidEndDateInput = this.isValidCalendarDate(endDateStr);
  }

  if (!isValidStartDateInput || (this.ENABLE_SETASIDE_CASH && !isValidEndDateInput)) {
    errFlag = true;
    this.tooltipMessage = "Specify a valid start date and end date to schedule a set-aside cash entry.";
    return errFlag;
  } else {
    let startDate = new Date(startDateStr);
    let endDate = new Date(endDateStr);
    let minDate = new Date(this.today);

    if (startDate < minDate) {
      errFlag = true;
      this.tooltipMessage = "Specify a valid start date to schedule a set-aside cash entry.";
      return errFlag;
    }
    if(this.ENABLE_SETASIDE_CASH && endDateStr) {
      if (endDate < startDate) {
        errFlag = true;
        this.tooltipMessage = "End date cannot be before the start date.";
        return errFlag;
      }
    }
  }

  if (this.setAsideAmountSymbol === "%") {
    if (this.value > 100) {
      errFlag = true;
      this.tooltipMessage = "Percentage values cannot be greater than 100";
    } else {
      errFlag = false;
    }
  } else {
    errFlag = false;
  }
  return errFlag;
  }

  hideToolTip() {
    this.tooltipShow = false;
    this.tooltipMessage = "";
  }

  onStartDateChange(event: any) {
    this.startDate = event.value;
    const startDateStr = this.startDate instanceof Date
    ? this.datePipe.transform(this.startDate, 'yyyy-MM-dd') + ' 12:00:00 GMT'
    : this.startDate;

  if (startDateStr) {
    const tomorrow = new Date(startDateStr);
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.endDateCalendarStartAt = tomorrow;
  }

  this.hideToolTip();
  }

  loadGrid() {
    if (this.cashNeedsData && this.grid && this.grid.api) {
      this.grid.api.setGridOption('rowData', this.cashNeedsData);
      this.activeRowCount = this.cashNeedsData.filter((item: any) => item.isActive && !item.isDeleted).length;

      this.expiredRowCount = this.cashNeedsData.filter((item: any) => {
        let d = new Date();
        d.setHours(0,0,0);
        let s = new Date(item.startDate);
        return !item.isActive && !item.isDeleted && (s.getTime() < d.getTime());
      }).length;
      this.calculateTotal();
      this.grid.api.setGridOption('pinnedBottomRowData', this.gls.getPinnedBottomRowData(this));
      this.grid.api.sizeColumnsToFit();
      this.grid.api.resetColumnState();
      this.grid.api.applyColumnState({state: null });
    }
  }

  calculateTotal() {
        const activeEntries = this.cashNeedsData.filter((item: any) => item.isActive && !item.isDeleted);
        if (activeEntries?.length > 0) {

          let total = 0;
          let isPercent = false;
          activeEntries.forEach((entry: any) => {
            const valueStr: string = entry.value?.toString() || '0';
            if (valueStr.includes('%') ) {
              isPercent = true;
            }
            let numericValue = 0;
            if (valueStr.includes('$') ) {
              numericValue = parseFloat(valueStr.replace(/[$%,]/g, '')) || 0;
            }
            total += numericValue;
          });
          this.activeAmount = isPercent ? '' : `$${total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        } else {
          this.activeAmount = '';
        }
  }
  deleteAll() {
    for (let i = 0; i < this.cashNeedsData.length; i++) {
      if( this.cashNeedsData[i].isNewSACadded) {
        this.cashNeedsData.splice(i--,1);
      } else {
        this.cashNeedsData[i].isDeleted = true;
      }
    }

    this.hideToolTip();
    this.loadGrid();
    this.data.oSetAsideDTO = (this.cashNeedsData.length > 0) ? this.cashNeedsData : null;
    this.change.emit(true);
  }

  delete(cc: any) {
    for (let i = 0; i < this.cashNeedsData.length; i++) {
      if (this.cashNeedsData[i].startDate === cc.startDate
      && (this.cashNeedsData[i].endDate === cc.endDate || (this.cashNeedsData[i].endDate === null && cc.endDate === null)) ) {
        if( this.cashNeedsData[i].isNewSACadded) {
          this.cashNeedsData.splice(i--,1);
        } else {
          this.cashNeedsData[i].isDeleted = true;
        }
        break;
      }
    }

    this.hideToolTip();
    this.loadGrid();
    this.data.oSetAsideDTO = (this.cashNeedsData.length > 0) ? this.cashNeedsData : null;
    this.change.emit(true);
  }

  cancelDelete() {
    this.ctas.remove();
  }

  onInputChange() {
    setTimeout(() => {
      if(!this.data.isGlobal) {
        if (this.data.isPercentage) {
          this.isValid = (!this.cashMinPerc?.inputControl.invalid || false) && (!this.cashTargetPerc?.inputControl.invalid || false) && (!this.cashMaxPerc?.inputControl.invalid || false);
        } else {
          this.isValid = (!this.cashMinDollar?.inputControl.invalid || false) && (!this.cashTargetDollar?.inputControl.invalid || false) && (!this.cashMaxDollar?.inputControl.invalid || false);              
        }
      } else {
        this.isValid = true;
      }
      if (this.trxCashMinSetting?.value === 'Set custom') {
        this.isValid = this.isValid && (!this.trxCashMinValueRef?.inputControl.invalid || false);
      }

      this.isValidChange.emit(this.isValid);
      this.change.emit(true);
    });
  }

  onCashTargetDollarChange(val: number) {
    if (this.data) {
      if (val || val === 0) {
        this.data.cashTarget = '$' + val;
      } else {
        this.data.cashTarget = null;
      }
      this.onInputChange();
    }
  }

  onCashMinDollarChange(val: number) {
    if (this.data) {
      if (val || val === 0) {
        this.data.cashMinimum = '$' + val;
      } else {
        this.data.cashMinimum = null;
      }
      this.onInputChange();
    }
  }

  onCashMaxDollarChange(val: number) {
    if (this.data) {
      if (val || val === 0) {
        this.data.cashMaximum = '$' + val;
      } else {
        this.data.cashMaximum = null;
      }
      this.onInputChange();
    }
  }

  onCashMinPercentChange(val: number) {
    if (this.data) {
      if (val || val === 0) {
        this.data.cashMinimum = val + '%';
      } else {
        this.data.cashMinimum = null;
      }
      this.onInputChange();
    }
  }

  onCashTargetPercentChange(val: number) {
    if (this.data) {
      if (val || val === 0) {
        this.data.cashTarget = val + '%';
      } else {
        this.data.cashTarget = null;
      }
      this.onInputChange();
    }
  }

  onCashMaxPercentChange(val: number) {
    if (this.data) {
      if (val || val === 0) {
        this.data.cashMaximum = val + '%';
      } else {
        this.data.cashMaximum = null;
      }
      this.onInputChange();
    }
  }
  loadCashMinimumMaximum() {
    this.tooltipShow = false;
    this.tooltipMessage = "";
    this.originalData = this.util.clone(this.data);
    if ((this.globalSettings?.useModelCash && this.data.isGlobal) || this.data.useModelCashAtAccount) {
      this.cashTarget = null;
      this.modelFlag = "Model";
    } else {
      if (this.data.isGlobal) {
        this.cashMinimum = this.originalData.globalCashMinimum.replace(/%/g, '').replace(/\$/g, '');
        this.cashMaximum = this.originalData.globalCashMaximum.replace(/%/g, '').replace(/\$/g, '');
        this.cashTarget = this.originalData.globalCashTarget.replace(/%/g, '').replace(/\$/g, '');
        this.data.isPercentage = (this.originalData.globalCashMinimum) ? this.originalData.globalCashMinimum.endsWith("%") : true;
      } else {
        this.cashMinimum = this.originalData.cashMinimum?.replace(/%/g, '').replace(/\$/g, '');
        this.cashMaximum = this.originalData.cashMaximum?.replace(/%/g, '').replace(/\$/g, '');
        this.cashTarget = this.originalData.cashTarget?.replace(/%/g, '').replace(/\$/g, '');
        this.data.isPercentage = this.originalData.isPercentage;
      }
      this.modelFlag = "";
    }
    this.onInputChange();
    this.cdr.detectChanges();
  }

  onSetAsideAmountSymbolChange() {
    this.setAsideAmountPlaceholder = (this.setAsideAmountSymbol === "%") ? "0%" : "$0";
    if (this.setAsideAmountSymbol === "$") this.value = Math.round(this.value);
    this.resetValue.emit();
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node: any) {
    return !node.data.isDeleted;
  }

  getRowCount() {
    return this.cashNeedsData ? this.cashNeedsData.length : 0;
  }

  getSetAsideCount(): number {
  if (!this.cashNeedsData) {
    return 0;
  }
    return this.cashNeedsData.filter((entry: ISetAsideDto) => !entry.isDeleted).length;
  }

  isValidCalendarDate(dateString: string) {
     try {
       const d = new Date(dateString);
       return !isNaN(d.valueOf());
     }
     catch (e) {
       return false;
     }
      return true;
  }

  ngAfterViewInit() {
      this.markAsTouched();
  }

  markAsTouched() {
      setTimeout(() => {
          this.cashMinPerc?.inputControl.markAsTouched();
          this.cashTargetPerc?.inputControl.markAsTouched();
          this.cashMaxPerc?.inputControl.markAsTouched();
          this.cashMinDollar?.inputControl.markAsTouched();
          this.cashTargetDollar?.inputControl.markAsTouched();
          this.cashMaxDollar?.inputControl.markAsTouched();
          this.trxCashMinValueRef?.inputControl.markAsTouched();
      });
  }

  disableAddButton() {
    if (this.setAsideAmountSymbol === '%' && this.setAsidePercent) {
      if (!this.setAsidePercent.inputControl.valid) {
        return true;
      }
    }
    if (this.setAsideAmountSymbol === '$' && this.setAsideDollar) {
      if (!this.setAsideDollar.inputControl.valid) {
        return true;
      }
    }
    const isValueValid = this.value === 0 ? true : !this.value ? false : true;
    return !this.startDate || !isValueValid;
  }

  toggleAutoCashHoldForDist() {
    this.updateAutoCashHoldForDistAmt();
    this.onInputChange();
  }

  updateAutoCashHoldForDistAmt() {
    this.showAutoCashHoldForDist = this.data?.autoCashHoldForDistAmt !== null;
  }

  openGlobalSettings() {
    this.as.fireEvent(IrbSettingsEvents.SHOW, {
      defaultTabIndex: 1, 
      onFirstLoad: () => { 
        setTimeout(() => { 
          this.as.fireEvent(IrbSettingsEvents.EXPAND_AUTO_CASH);
          document.getElementById("AUTO_CASH")?.scrollIntoView(); 
        });
      }
    });
  }
}
